import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import "dayjs/locale/nl";
import "dayjs/locale/de";

const DAYJS_LOCALES: Record<string, string> = {
  nl: "nl",
  "nl-NL": "nl",
  "nl-BE": "nl",
  de: "de",
  "de-DE": "de",
  "de-AT": "de",
  "de-CH": "de",
  en: "en",
  "en-US": "en",
  "en-GB": "en",
};

function dayjsLocaleFor(lang: string): string {
  const key = (lang || "en").split("-")[0];
  return DAYJS_LOCALES[lang] ?? DAYJS_LOCALES[key] ?? "en";
}

/**
 * Returns a date formatter that uses the current i18n language for dayjs (e.g. month names).
 * Usage: formatDate(date) => "15 jan 2025" (nl) or "15 Jan 2025" (en)
 */
export function useFormatDate() {
  const { i18n } = useTranslation();
  const locale = dayjsLocaleFor(i18n.language || "en");

  return useCallback(
    (date: string | Date, format = "DD MMM YYYY") => {
      return dayjs(date).locale(locale).format(format);
    },
    [locale]
  );
}
